module.exports = __webpack_public_path__ + "img/symbol_2.9db2a7d3.png";